/**
 * Promise based delay
 * @param {Number} milliseconds
 * @returns {Promise<void>} a new Promise that resolves with undefined after the set milliseconds.
 */
export const delay = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
